<template>
  <v-container fluid class="fs-admin-container">
    <v-layout class="fs-archive" mb-3>
      <v-flex mb-3>
        <h1>{{title}}</h1>
      </v-flex>
    </v-layout>
    <v-layout wrap class="fs-header-filter">
      <v-flex md2>
        <RangeDatePicker
          startDateLabel="Дата с"
          endDateLabel="Дата до"
          :startDate.sync="filter.start_at"
          :endDate.sync="filter.end_at"
          @changeRange="filterEvents"
          dense
        />
      </v-flex>
      <v-flex md2>
        <v-autocomplete
          v-model="filter.event"
          :items="passageEvents"
          :item-text="'name'"
          :item-value="'id'"
          flat
          dense
          label="Тип прохода:"
          class="fs-admin-complex-autocomplete"
          @change="filterEvents"
        />
      </v-flex>
    </v-layout>
    <v-layout class="fs-admin-archive-result" mb-3 justify-space-around>
      <v-flex>
        <Table
          :headers="headers"
          :items="items"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="totalItems"
          :page.sync="page"
          @update:request="updateRequest"
          disable-sort
          no-data-text="Информация о проходах отсуствует"
          class="elevation-1"
        >
          <template v-slot:item.is_in="{ item }">
            {{ item.is_in ? 'Вход' : 'Выход' }}
          </template>
        </Table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { BASE, FORMAT } from '@/config'
import { GET_CHILD_PASSAGES } from '@/requests/parent'
import { Table, RangeDatePicker } from '@/components/common'

export default {
  name: 'Passages',
  components: {
    Table,
    RangeDatePicker
  },
  data() {
    return {
      title: 'Проходы ребенка',
      headers: [
        { text: 'Дата и время', value: 'passageDate' },
        { text: 'Номер карты', value: 'number' },
        { text: 'Событие', value: 'event.name' },
        { text: 'Направление', value: 'is_in' },
        { text: 'Турникет', value: 'gate' },
        { text: 'Примечание', value: 'reason_text' },
      ],
      items: [],
      dataTableLoaded: false,
      page: 1,
      itemsPerPage: BASE.LIMIT,
      offset: 0,
      totalItems: 0,
      filter: {
        start_at: moment().add('days', -7).format(FORMAT.datepickerDate),
        end_at: moment().format(FORMAT.datepickerDate),
        event: null
      },
      eventTypes: []
    }
  },
  created() {
    this.loadPassages()
  },
  computed: {
  ...mapState({
      childId: state => state.child.childId,
      cardConstants: state => state.common.constants.card_events,
      passageEvents: state => {
        return state.common.constants.card_events.passage.map(evId =>
          state.common.constants.card_events.value.find(e => e.id === evId)
        )
      }
    })
  },
  methods: {
    updateRequest({ offset, itemsPerPage }) {
      this.offset = offset
      this.itemsPerPage = itemsPerPage
      this.loadPassages()
    },
    filterEvents() {
      this.page = 1
      this.offset = 0
      this.loadPassages()
    },
    async loadPassages() {
      try {
        const { data: { results, count }} = await GET_CHILD_PASSAGES(this.childId, {
          limit: this.itemsPerPage,
          offset: this.offset,
          date_from: this.filter.start_at ? moment(this.filter.start_at).format(FORMAT.datepickerDate) : null,
          date_to: this.filter.end_at ? moment(this.filter.end_at).format(FORMAT.datepickerDate) : null,
          event: this.filter.event,
        })

        this.totalItems = count
        this.items = results.map(r => ({
          ...r,
          event: this.cardConstants.value.find(p => p.id === r.event),
          passageDate: moment(r.passage_at).format(FORMAT.dateTimeShort)
        }))
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось получить список проходов'
        })
      }
    }
  }
}
</script>